import React from "react";
import { FaExternalLinkAlt } from "react-icons/fa";
import { Link } from "react-router-dom";

export default function SingleVerticalMedia() {
  return (
    <div className="single-vertical-parent">
      <div className="vertical-title">
        <div className="text-900 font-bold text-7xl mb-4 text-center">
          FlexNet Construction: Building Smarter with 5G Connectivity
        </div>
        <div className="text-700 text-xl mb-6 text-center line-height-3">
          Enhance safety, productivity, and project management with FlexNet’s
          private 4G/5G solutions for construction sites.
        </div>
      </div>
      {/* Hero Section */}
      <div className="grid grid-nogutter surface-section text-800 ">
        <div className="col-12 md:col-6 p-6 text-center md:text-left flex align-items-center">
          <section>
            <span className="block text-6xl font-bold mb-3">
              FlexNet Construction
            </span>
            <div className="text-6xl text-primary font-bold mb-3">
              Revolutionizing Operations with 5G Connectivity
            </div>
            <p className="mt-0 mb-4 text-700 line-height-3">
              FlexNet revolutionizes construction with reliable 5G connectivity
              for enhanced worker safety, real-time equipment tracking, and
              optimized project management.
            </p>
            <button className="flex underline align-items-center mt-4">
              <Link to="/connectivity">Request Demo</Link>
              <FaExternalLinkAlt className="ml-2" />
            </button>
          </section>
        </div>
        <div className="col-12 md:col-6 overflow-hidden">
          <img
            src="https://img.freepik.com/premium-photo/construction-site-with-workers-wearing-smart-helmets-all-connected-via-wireless-network_216520-112338.jpg"
            alt="hero-1"
            className="md:ml-auto block md:h-full"
            style={{ clipPath: "polygon(8% 0, 100% 0%, 100% 100%, 0 100%)" }}
          />
        </div>
      </div>

      {/* Key Benefits Section */}
      <div className="surface-section px-4 py-8 md:px-6 lg:px-8 text-center">
        <div className="mb-3 font-bold text-3xl">
          <span className="text-900">Why </span>
          <span className="text-blue-600">FlexNet for Construction?</span>
        </div>
        <div className="grid justify-center">
          {keyBenefits.map((benefit, index) => (
            <div key={index} className="col-12 md:col-4 mb-4 px-5">
              <span
                className="p-3 shadow-2 mb-3 inline-block surface-card"
                style={{ borderRadius: "10px" }}
              >
                <i className={`${benefit.icon} text-4xl text-blue-500`}></i>
              </span>
              <div className="text-900 text-xl mb-3 font-medium">
                {benefit.title}
              </div>
              <span className="text-700 line-height-3">{benefit.detail}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Use Cases Section */}

      <div className="mb-3 font-bold text-3xl">
        <span className="text-900">FlexNet Manufacturing </span>
        <span className="text-blue-600">Use Cases</span>
      </div>
      {useCases.map((useCase, index) => (
        <div
          key={index}
          className="surface-section px-4 py-8 md:px-6 lg:px-8 text-center"
        >
          <div className="b-3 font-bold text-2xl mb-3">
            <span className="text-blue-600">Use Case</span>
            {useCase.title}
          </div>
          <div className="text-700 mb-6">{useCase.description}</div>
          <div className="grid">
            <div className="col-12 md:col-4 mb-4 px-5">
              <div className="text-900 text-xl mb-3 font-medium">Benefits</div>
              {useCase.benefits.map((item, idx) => (
                <div key={idx} className="mb-2">
                  <i className={`${item.icon} text-blue-500 mr-2`}></i>
                  {item.title}
                </div>
              ))}
            </div>
            <div className="col-12 md:col-4 mb-4 px-5">
              <div className="text-900 text-xl mb-3 font-medium">
                Devices/Technologies
              </div>
              {useCase.devices.map((item, idx) => (
                <div key={idx} className="mb-2">
                  <i className={`${item.icon} text-blue-500 mr-2`}></i>
                  {item.title}
                </div>
              ))}
            </div>
            <div className="col-12 md:col-4 mb-4 px-5">
              <div className="text-900 text-xl mb-3 font-medium">
                Applications
              </div>
              {useCase.applications.map((item, idx) => (
                <div key={idx} className="mb-2">
                  <i className={`${item.icon} text-blue-500 mr-2`}></i>
                  {item.title}
                </div>
              ))}
            </div>
            <button className="flex underline align-items-center mt-4 vertical-market-link">
              <Link to="/marketplace">Request Access to Marketplace</Link>
              <FaExternalLinkAlt className="ml-2" />
            </button>
          </div>
        </div>
      ))}

      {/* Case Studies Testimonias Section */}
      <div className="surface-section px-4 py-8 md:px-6 lg:px-8 text-center">
        <div className="mb-3 font-bold text-3xl">
          <span className="text-blue-600">Testimonials/Case Studies</span>
        </div>
        <div className="grid justify-center">
          <div className="col-12 md:col-4 mb-4 px-5">
            <div className="text-900 text-xl mb-3 font-medium">
              Success Stories in Smart Construction
            </div>
            <div className=" vertical-testimonials">
              <div className="text-700 line-height-3 vertical-testimonials-box text-xl">
                <span className="text-blue-600">
                  Major Urban Development Project Problem:
                </span>{" "}
                Poor site communication and safety monitoring.
                <br />
                <br />
                <span className="text-blue-600"> Solution:</span> FlexNet
                private 5G deployment with smart helmets, IoT asset tracking,
                and AI-powered cameras. Outcome: Improved worker safety,
                enhanced site security, and efficient project management.
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Call-to-Action Section */}
      <div className="surface-section text-center py-8">
        <div className="text-900 text-3xl font-bold mb-4">
          Ready to Build Smarter with FlexNet?
        </div>

        <button className="p-button p-button-raised connectivity-request-demo-button p-3">
          <Link to="contact-page">Get in Touch for a Personalized Demo</Link>
        </button>
      </div>
    </div>
  );
}

const keyBenefits = [
  {
    title: "Real-Time Monitoring of Equipment and Worker Safety",
    detail: "Enhance site security and worker protection with real-time data.",
    icon: "pi pi-eye",
  },
  {
    title: "AI-Powered Surveillance",
    detail: "Improve site security with automated threat detection.",
    icon: "pi pi-video",
  },
  {
    title: "Efficient Project Management",
    detail:
      "Utilize IoT connectivity for real-time tracking and workflow automation.",
    icon: "pi pi-cog",
  },
  {
    title: "Instant Data Sharing & Communication",
    detail:
      "Enable seamless communication between teams with low-latency networks.",
    icon: "pi pi-comments",
  },
  {
    title: "Predictive Maintenance for Equipment",
    detail: "Reduce downtime and optimize machinery lifespan with IoT sensors.",
    icon: "pi pi-chart-line",
  },
];

const useCases = [
  {
    title: " 1: Worker Safety with Smart Helmets and Wearables",
    description:
      "Equip construction workers with 4G/5G-enabled smart helmets and wearables for real-time health and safety monitoring.",
    benefits: [
      { title: "Emergency calls and video communication", icon: "pi pi-phone" },
      { title: "Fall detection and geo-fencing", icon: "pi pi-map" },
      {
        title: "Automatic photo uploads for site documentation",
        icon: "pi pi-upload",
      },
    ],
    devices: [
      { title: "4G/5G Smart Helmets", icon: "pi pi-mobile" },
      { title: "Wearables", icon: "pi pi-clock" },
      { title: "IoT Gateways", icon: "pi pi-cloud" },
    ],
    applications: [
      { title: "Worker Safety Monitoring Platforms", icon: "pi pi-desktop" },
    ],
  },
  {
    title: " 2: Real-Time Monitoring via 5G NR Cameras",
    description:
      "Deploy 5G-enabled cameras across construction sites for real-time monitoring and project oversight.",
    benefits: [
      { title: "Enhanced site security and surveillance", icon: "pi pi-lock" },
      {
        title: "Real-time tracking of construction progress",
        icon: "pi pi-chart-bar",
      },
      { title: "Remote management of site operations", icon: "pi pi-globe" },
    ],
    devices: [
      { title: "5G NR Cameras", icon: "pi pi-camera" },
      { title: "IoT Monitoring Platforms", icon: "pi pi-cloud" },
    ],
    applications: [
      {
        title: "Construction Site Surveillance Systems",
        icon: "pi pi-desktop",
      },
    ],
  },
  {
    title: " 3: Connected Workers & Operations",
    description:
      "Integrate connected tools and wearables for streamlined operations and improved worker coordination.",
    benefits: [
      {
        title: "Real-time communication between teams",
        icon: "pi pi-comments",
      },
      {
        title: "Enhanced coordination and task management",
        icon: "pi pi-users",
      },
      { title: "Improved operational efficiency", icon: "pi pi-sync" },
    ],
    devices: [
      { title: "Wearables", icon: "pi pi-clock" },
      { title: "Connected Tools", icon: "pi pi-wrench" },
      { title: "IoT Devices", icon: "pi pi-cloud" },
    ],
    applications: [
      {
        title: "Construction Operations Management Platforms",
        icon: "pi pi-desktop",
      },
    ],
  },
  {
    title: " 4: Predictive Maintenance for Construction Equipment",
    description:
      "Utilize IoT sensors to monitor construction machinery and predict maintenance needs to prevent equipment failures.",
    benefits: [
      {
        title: "Minimize downtime with proactive maintenance",
        icon: "pi pi-clock",
      },
      { title: "Extend equipment lifespan", icon: "pi pi-cog" },
      {
        title: "Reduce repair costs and operational delays",
        icon: "pi pi-dollar",
      },
    ],
    devices: [
      { title: "Vibration Sensors", icon: "pi pi-sliders-h" },
      { title: "Temperature Sensors", icon: "pi pi-sun" },
      { title: "IoT Gateways", icon: "pi pi-cloud" },
    ],
    applications: [
      { title: "Predictive Maintenance Platforms", icon: "pi pi-desktop" },
    ],
  },
  {
    title: " 5: IoT-Enabled Asset Tracking",
    description:
      "Implement IoT solutions for real-time tracking of construction assets and materials.",
    benefits: [
      { title: "Prevent loss or theft of equipment", icon: "pi pi-lock" },
      { title: "Optimize resource allocation", icon: "pi pi-chart-pie" },
      {
        title: "Improve project timelines and efficiency",
        icon: "pi pi-calendar",
      },
    ],
    devices: [
      { title: "RFID Tags", icon: "pi pi-tag" },
      { title: "GPS Trackers", icon: "pi pi-map" },
      { title: "IoT Sensors", icon: "pi pi-cloud" },
    ],
    applications: [
      { title: "Construction Asset Management Systems", icon: "pi pi-desktop" },
    ],
  },
];
